import { Badge } from "theme-ui";
import * as React from 'react';
export default {
  Badge,
  React
};